import { render, staticRenderFns } from "./LoginFlowStepPassword.vue?vue&type=template&id=10bb9f80&scoped=true&"
import script from "./LoginFlowStepPassword.vue?vue&type=script&lang=ts&"
export * from "./LoginFlowStepPassword.vue?vue&type=script&lang=ts&"
import style0 from "./LoginFlowStepPassword.vue?vue&type=style&index=0&id=10bb9f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bb9f80",
  null
  
)

export default component.exports